import MarcaList from './MarcaList'
export {MarcaList}
export default MarcaList
